/* Buscar en todo el viaje: paradas, billetes (con su localizador a la vista), compras y frases.
   Sin tildes ni mayúsculas: «todai» encuentra «Tōdai-ji». */
import { FRASES } from '../datos/frases.ts';
import { enlaces, sinTildes } from '../datos/reservas.ts';
import type { Viaje } from '../datos/tipos.ts';
import { tituloCompra } from '../datos/compras.ts';
import { fechaCorta, num2, titulo } from '../texto.ts';

interface Resultado { clave: string; grupo: string; donde: string; texto: string; extra?: string; ir?: { n: number; bloque: string } }

const MAX = 40;

export function buscar(v: Viaje, q: string): Resultado[] {
  const t = sinTildes(q.trim());
  if (t.length < 2) return [];
  const hay = (...xs: (string | null | undefined)[]) => xs.some(x => x && sinTildes(x).includes(t));
  const r: Resultado[] = [];
  const enl = enlaces(v);
  const bloqueDe = (id: string) => [...enl.porBloque].find(([, rs]) => rs.some(x => x.id === id))?.[0];
  for (const d of v.dias) for (const b of d.bloques)
    if (hay(b.que, b.plan)) r.push({ clave: `b${b.id}`, grupo: 'Paradas', donde: `JP${num2(d.n)} · ${fechaCorta(d)} · ${b.hora.split('–')[0]}`, texto: titulo(b.que), extra: b.plan, ir: { n: d.n, bloque: b.id } });
  for (const x of v.reservas)
    if (hay(x.que, x.localizador, x.proveedor, x.notas)) {
      const b = bloqueDe(x.id), d = x.dia ? v.dias[x.dia - 1] : undefined;
      r.push({ clave: `r${x.id}`, grupo: 'Billetes', donde: d ? `JP${num2(d.n)} · ${fechaCorta(d)}` : 'Todo el viaje', texto: titulo(x.que),
        extra: [x.localizador && x.localizador !== '—' ? `Localizador ${x.localizador}` : '', x.estado?.toLowerCase()].filter(Boolean).join(' · '),
        ir: b && x.dia ? { n: x.dia, bloque: b } : undefined });
    }
  for (const c of v.compras) if (hay(c.que, c.para, c.donde)) r.push({ clave: `c${c.id}`, grupo: 'Compras', donde: c.donde && c.donde !== '—' ? c.donde : 'Compras', texto: tituloCompra(c) });
  for (const f of [...v.frases, ...FRASES]) if (hay(f.es, f.romaji)) r.push({ clave: `f${f.ja}`, grupo: 'Frases', donde: f.situacion, texto: f.es, extra: `${f.ja} · ${f.romaji}` });
  return [...new Map(r.map(x => [x.clave, x])).values()];
}

export function Buscador({ v, q, onIr }: { v: Viaje; q: string; onIr: (n: number, bloque: string) => void }) {
  const res = buscar(v, q);
  if (!res.length) return <p className="texto">Nada con «{q}».</p>;
  const grupos = [...new Set(res.map(x => x.grupo))];
  return (
    <div className="busqueda" aria-live="polite">
      <p className="oculto">{res.length} resultados</p>
      {grupos.map(g => {
        const de = res.filter(x => x.grupo === g);
        return (
          <section key={g}>
            <h3>{g} · {de.length}</h3>
            <ul>
              {de.slice(0, MAX).map(x => {
                const cuerpo = <><small>{x.donde}</small><b>{x.texto}</b>{x.extra && <span lang={g === 'Frases' ? 'ja' : undefined}>{x.extra}</span>}</>;
                return <li key={x.clave}>{x.ir ? <button type="button" onClick={() => onIr(x.ir!.n, x.ir!.bloque)}>{cuerpo}</button> : <div>{cuerpo}</div>}</li>;
              })}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
